<template>
    <div class="mt-2" v-if="awards != null && awards.length > 0">
        <div class="award-badges row" v-if="displayBadges == true">
            <b>Awards</b>
            <div class="col-6 col-sm-3 my-3" v-for="award, index in awards" :key="index">
                <img class="d-block img-fluid" :src="award.path" :alt="award.name + ' image'" />
            </div>
        </div>
        <div v-else>
            <div class="award-count badge fw-light" v-if="awards.length > 0">
                <a :href="tyreUrl">
                    <p>{{ awards.length }} award{{ awards.length != 1 ? 's' : ''}}</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['awards', 'tyreUrl', 'displayBadges']
    }
</script>